import React, {useEffect, useState} from 'react'
import Collapse, {CollapseEnumType} from '../Collapse/Collapse'
import {IconTypeEnum} from '../../theme/icons'
import {StyledSeparator, StyledSeparatorDiv, StyledSideNavBar, StyledSideNavBarSubList,} from './SideNavigation.styled'
import UrlFactory from '../../utils/UrlFactory'
import useNavigationType from '../../hooks/useNavigationType'
import PropTypes from 'prop-types'
import {useSideNavigationQuery} from "../../graphql/useSideNavigationQuery";

export const SideNavTypeEnum = Object.freeze({
  product: 'Product',
  investor: 'Investor',
})

const isBrowser = typeof window !== 'undefined'

const SideNavigation = (props) => {
  const {variant} = props
  const data = useSideNavigationQuery()
  if (data.contentfulComponentTreeStructure === null) return null

  const edges = data?.allContentfulComponentTreeStructure?.edges
  const [investor, product] = useNavigationType(edges)
  const [list, setList] = useState(null)
  const [navItems, setNavItems] = useState(null)
  if (variant === SideNavTypeEnum.product && !product) return null
  if (variant === SideNavTypeEnum.investor && !investor) return null

  const pageSecFilings = {
    id: 'sec-filings',
    slug: 'investors/sec-filings',
    pageTitle: 'SEC Filings',
  }

  useEffect(() => {
    let listItems = variant === SideNavTypeEnum.product ? product : investor
    if (variant === SideNavTypeEnum.investor && !listItems?.parentItems?.find(e => e.id === 'sec-filings')) {
      listItems?.parentItems?.splice(1, 0, pageSecFilings) // add page on the second position in investor tree structure
    }
    setList(listItems)
    setNavItems(navItemsGenerator(listItems?.parentItems))
  }, [])


  // TODO refacto with Drawer
  const navItemsGenerator = (links, isChild = false) => {
    if (isBrowser) {
      return links.map((link, index) => {
        const fullSlug =
          variant === SideNavTypeEnum.product
            ? UrlFactory.getProductUrl(link.slug)
            : UrlFactory.getInvestorsUrl(link.slug)

        const currentSlug =
          isChild ||
          link.descriptionHtml ||
          variant === SideNavTypeEnum.investor
            ? fullSlug
            : null

        const children = link.childrenProducts ?? false
        const isLast = !isChild && links.length === index + 1
        const sublinks =
          children && navItemsGenerator(link.childrenProducts, true)
        const title = link.shortTitle ?? link.title ?? link.pageTitle
        const currentPage = window.location.pathname.includes(fullSlug)
        const childPage =
          children !== null &&
          children !== false &&
          !!children.find((child) =>
            window.location.pathname.includes(child.slug)
          )

        return (
          <div key={title + index + 'div'}>
            <Collapse
              collapseType={CollapseEnumType.SideNav}
              isChild={isChild}
              iconType={IconTypeEnum.add}
              key={title + index}
              name={title}
              currentPage={currentPage}
              childPage={childPage}
              childrenSlugs={link.childrenProducts}
              to={children ? null : `/${currentSlug}`}
            >
              {sublinks && (
                <StyledSideNavBarSubList key={title + index + 'sub'}>
                  {sublinks}
                </StyledSideNavBarSubList>
              )}
            </Collapse>
            {!isChild && !isLast && (
              <StyledSeparatorDiv>
                <StyledSeparator key={title + index + 'sep'}/>
              </StyledSeparatorDiv>
            )}
          </div>
        )
      })
    }
    return null
  }

  return (
    <div>
      {
        <StyledSideNavBar>
          {/* Add Manual SEC Filings if Investors Page */}
          {navItems}
        </StyledSideNavBar>
      }
    </div>
  )
}

SideNavigation.propTypes = {
  variant: PropTypes.string,
}

export default SideNavigation
